var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"image-container",style:({
    float: _vm.content.position == 'left' ? 'left' : _vm.content.position == 'right' ? 'right' : '',
    verticalAlign: _vm.content.verticalAlign || ''
  }),attrs:{"id":_vm.content.key}},[_c('el-image',{staticClass:"image",style:({
      display: _vm.content.position == 'inline' ? 'inline-block' : '',
      width: _vm.content.width ? _vm.content.width + 'rem' : ''
    }),attrs:{"id":((_vm.content.key) + "-1"),"src":_vm.content.url,"alt":"","preview-src-list":[_vm.content.url]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }